import { render, staticRenderFns } from "./EditorImage.vue?vue&type=template&id=6f754979&scoped=true"
import script from "./EditorImage.vue?vue&type=script&lang=js"
export * from "./EditorImage.vue?vue&type=script&lang=js"
import style0 from "./EditorImage.vue?vue&type=style&index=0&id=6f754979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f754979",
  null
  
)

export default component.exports